export const scVarTransitionDuration = '2s';
